<template>
  <div>
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4">
          <strong>Detail Dokter</strong>
        </h5>
        <a-spin v-if="isLoading" />
        <a-form :form="form" @submit="handleSubmit" v-if="!isLoading">
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Nama Lengkap"
          >
            <a-input
              :disabled="submitting"
              placeholder="Nama Lengkap"
              v-decorator="[
                'fullname',
                {
                  rules: [
                    { required: true, message: 'Nama lengkap harus diisi!' },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Nomor KTP"
          >
            <a-input
              :disabled="submitting"
              placeholder="Nomor KTP"
              v-decorator="['idNumber']"
            />
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Alamat E-mail"
          >
            <a-input
              :disabled="submitting"
              placeholder="Alamat E-mail"
              v-decorator="['email']"
            />
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Rumah Sakit"
          >
            <a-input
              :disabled="submitting"
              placeholder="Rumah Sakit"
              v-decorator="[
                'hospital',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Nama rumah sakit harus diisi!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Provinsi"
          >
            <a-select
              :disabled="submitting"
              allowClear
              v-decorator="['province']"
              placeholder="Provinsi"
              @change="handleChangeProvince"
            >
              <a-select-option
                v-for="prov in provinceList"
                :key="prov"
                :value="prov"
              >
                {{ prov }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Kota"
          >
            <a-select
              :disabled="submitting"
              allowClear
              v-decorator="[
                'city',
                { rules: [{ required: false }] },
              ]"
              placeholder="Kota"
            >
              <a-select-option
                v-for="city in cityList"
                :key="city.id"
                :value="city.name"
              >
                {{ city.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Kode Verifikasi"
          >
            <a-input
              :disabled="submitting"
              placeholder="Kode Verifikasi"
              v-decorator="['verificationCode']"
            />
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Program"
          >
            <a-select
              mode="multiple"
              style="width: 100%"
              placeholder="Program Type"
              v-decorator="[
                'programTypes',
                {
                  rules: [
                    { required: true, message: 'Program Types harus diisi!' },
                  ],
                },
              ]"
            >
              <a-select-option
                v-for="(pro, i) in programTypes"
                :key="i"
                :value="pro.name"
                >{{ pro.name }}</a-select-option
              >
              <!-- <a-select-option value="TAGRISSO">
                TAGRISSO
              </a-select-option>
              <a-select-option value="FASLODEX">
                FASLODEX
              </a-select-option>
              <a-select-option value="LYNPARZA">
                LYNPARZA
              </a-select-option>
              <a-select-option value="IMFINZI">
                IMFINZI
              </a-select-option>
              <a-select-option value="CALQUENCE">
                CALQUENCE
              </a-select-option> -->
              <a-select-option value="FASENRA"> FASENRA </a-select-option>
            </a-select>
          </a-form-item>
          <button
            type="submit"
            class="btn btn-success px-5"
            :disabled="submitting"
          >
            Simpan Data
          </button>
          <button
            class="btn btn-danger px-5 m-1"
            :disabled="submitting"
            @click="
              (e) => {
                e.preventDefault()
                setModalVisible(true)
              }
            "
          >
            Hapus Data
          </button>
          <button
            class="btn btn-secondary px-5"
            :disabled="submitting"
            @click="handleCancel"
          >
            Kembali
          </button>
        </a-form>
      </div>
    </div>
    <a-modal
      title="Konfirmasi"
      :dialog-style="{ top: '20px' }"
      :visible="modalVisible"
      @ok="() => handleDelete()"
      @cancel="() => setModalVisible(false)"
    >
      Apakah Anda yakin akan menghapus data dokter
      {{ form.getFieldValue('fullname') }}?
    </a-modal>
  </div>
</template>
<script>
import { getById, editById, deleteById } from '@/services/axios/api/dokter'
import router from '@/router'
import { getAll, getProvinces } from '@/services/axios/api/city'
import { notification } from 'ant-design-vue'
import apiClient from '../../../services/axios'

const labelCol = {
  xs: { span: 24 },
  sm: { span: 4 },
}
const wrapperCol = {
  xs: { span: 24 },
  sm: { span: 12 },
}
export default {
  data: function () {
    return {
      form: this.$form.createForm(this),
      labelCol,
      wrapperCol,
      cityList: [],
      programTypes: [],
      provinceList: [],
      isLoading: true,
      submitting: false,
      modalVisible: false,
    }
  },
  created() {
    this.getDoctorById()
    this.getProvinceList()
    this.getCityList()
    this.getProgramType()
  },
  methods: {
    async getProvinceList() {
      const res = await getProvinces()
      this.provinceList = res
    },
    async handleChangeProvince(val) {
      this.form.setFieldsValue({
        city: undefined,
      })
      this.cityList = []
      await this.getCityList(val)
    },
    async getDoctorById() {
      // init form field
      this.form.getFieldDecorator('fullname', { initialValue: '' })
      this.form.getFieldDecorator('email', { initialValue: '' })
      this.form.getFieldDecorator('city', { initialValue: '' })
      this.form.getFieldDecorator('province', { initialValue: '' })
      this.form.getFieldDecorator('hospital', { initialValue: '' })
      this.form.getFieldDecorator('verificationCode', { initialValue: '' })
      this.form.getFieldDecorator('idNumber', { initialValue: '' })
      this.form.getFieldDecorator('programTypes', { initialValue: '' })

      // get data
      const res = await getById(this.$route.params.id)

      // set loading false
      this.isLoading = false

      if (res) {
        // set form data
        const programTypes = []
        for (const i in res.programTypes) {
          programTypes.push(res.programTypes[i].name)
        }
        this.form.setFieldsValue({ fullname: res.fullname })
        this.form.setFieldsValue({ email: res.email })
        if (res.province) {
          this.form.setFieldsValue({ province: res.province })
          await this.getCityList(res.province)
        } else {
          await this.getCityList()
        }
        this.form.setFieldsValue({ city: res.city })
        this.form.setFieldsValue({ hospital: res.hospital })
        this.form.setFieldsValue({ verificationCode: res.verificationCode })
        this.form.setFieldsValue({ idNumber: res.idNumber })
        this.form.setFieldsValue({ programTypes: programTypes })
      }
    },
    async getCityList(province) {
      const res = await getAll({ province })
      this.cityList = res
    },
    async getProgramType() {
      const res = await apiClient.get('/programType')
      this.programTypes = res.data
      // console.log(res.data, '<<<<')
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.submitting = true
          console.log('Received values of form: ', values)
          try {
            const res = await editById(this.$route.params.id, values)
            if (res && res.data) {
              notification.success({
                message: 'Sukses',
                description: 'Data berhasil disimpan',
                duration: 5,
              })
              router.push('/dokter')
            }
            this.submitting = false
          } catch (e) {
            this.submitting = false
          }
        }
      })
    },
    async handleDelete() {
      const res = await deleteById(this.$route.params.id)
      if (res && res.data) {
        notification.success({
          message: 'Sukses',
          description: 'Data berhasil dihapus',
          duration: 5,
        })
        router.push('/dokter')
      } else {
        notification.warning({
          message: 'Gagal',
          description: 'Data gagal dihapus',
          duration: 5,
        })
      }
      this.submitting = false
      this.modalVisible = false
    },
    handleCancel(e) {
      e.preventDefault()
      router.push('/dokter')
    },
    setModalVisible(modalVisible) {
      this.modalVisible = modalVisible
    },
  },
}
</script>
